/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bms_Module_ManagementInputs */



/**
* | output |
* | --- |
* | "BMS module management" |
*
* @param {Bms_Module_ManagementInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const bms_module_management = /** @type {((inputs?: Bms_Module_ManagementInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bms_Module_ManagementInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("BMS module management")
	return /** @type {LocalizedString} */ ("Gestion des modules GTB")
});